export default [
  {
    path: '/',
    name: 'Home',
    page: 'Home'
  },
  {
    path: '/login/:id?',
    name: 'Login',
    page: 'Login'
  },
  {
    path: '/urna',
    name: 'Urna',
    page: 'Urna',
    authRequired: true
  },
  {
    path: '/vote',
    name: 'Vote',
    page: 'Vote',
    authRequired: true
  },
  {
    path: '/Election',
    name: 'Election',
    page: 'Election'

  },
  {
    path: '/Mosaico',
    name: 'MosaicUrn',
    page: 'MosaicUrn',
    authRequired: true
  },
  {
    path: '/passwordReset',
    name: 'PasswordResetExecution',
    page: 'PasswordResetExecution'
  },
  {
    path: '/ReenvioEmail',
    name: 'EmailResend',
    page: 'EmailResend'
  },
  {
    path: '/CadastroEleitor',
    name: 'VoterRegistration',
    page: 'VoterRegistration'
  },
  {
    path: '/RedefinirSenha',
    name: 'PasswordResetRequest',
    page: 'PasswordResetRequest'
  },
  {
    path: '/Alert',
    name: ''
  },
  //! This statement should be placed at the end.
  {
    path: '*',
    name: '404',
    page: '404',
    electionRequired: true
  }
];
